import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

const CommonSlider = ({ children, settings = {}, slides = {} }) => {

  const defaultSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    ...settings,
    responsive: [
      {
        breakpoint: 1490,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 1170,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
    // responsive: Object.entries(slides || {})
    //   .map(([key, value]) => ({
    //     breakpoint: Number(key),
    //     settings: { slidesToShow: value, slidesToScroll: 1 },
    //   }))
    //   .sort((a, b) => a.breakpoint - b.breakpoint)
  };

  return (
    <div>
      <Slider {...defaultSettings}>
        {children}
      </Slider>
    </div>
  );
};

export default CommonSlider;